export const config = {

  webWorker: typeof window === 'undefined',

  development: process.env.MODE == 'development',

  domain: 'goalswizard.com',

  sentryDSN: 'https://c05fd6fd28b84729b75ff9e53dc6cf3e@o335160.ingest.sentry.io/4504759237083136',

  googleCalendar: {
    apiKey: 'AIzaSyBfrM-RWSw3WoGEw75rwwB_JOTvv1ObQyo',
    clientId: '984971438931-pe44k26on98n2ka5b1vukelv8thg9me8.apps.googleusercontent.com',
  },

  deviceId: new Date().getTime(),

  app: 'gw',
  appHost: process.env.MODE == 'development' ? 'localhost' : 'goalswizard.com',
  appName: 'Goals Wizard',
  appStoreURL: 'https://itunes.apple.com/app/id901800555',
  clarityModule: 'clarity',
  todayModule: 'Today',
  eveningRoutine: 'Evening Routine',
  googlePlayURL: 'https://play.google.com/store/apps/details?id=com.way4app.goalswizard&hl=en',
  gw: true,
  identityModule: 'identity',
  morningRoutine: 'Morning Routine',
  proPlan: 'Advanced',

  questions: {
    morning_thoughts_10: "What\'s important for me today?",
    morning_thoughts_20: "What are my intentions for today? What should I focus on?",
    reflections_1_10: "What were my 'high' and 'low' points – the best and worse experiences today?",
    reflections_1_20: "What made me motivated and energized today?",
    reflections_1_30: "What made me angry, worried or frustrated?",
    reflections_1_40: "What caused me to waste time or lose focus today?",
    reflections_1_50: "What did I learn today? How can I benefit from it?",
    reflections_1_60: "What and how should I do differently tomorrow?",
    reflections_2_10: "What am I grateful for?",
    reflections_2_20: "How did I spend my time today?",
    reflections_2_30: "Did I follow my plan? Was I productive?",
    reflections_2_40: "What were my time wasters today?",
    reflections_2_50: "How can I avoid them tomorrow?",
    reflections_3_10: "What did I accomplish today?",
    reflections_3_20: "Did I complete all my planned activities? Why?",
    reflections_3_30: "What inspired and energized me today?",
    reflections_3_40: "What should I focus on tomorrow?",
    reflections_3_50: "What should I do tomorrow to make it a better day?",
    reflections_4_10: "Are you making progress towards your goal? How can you do better?",
    reflections_4_20: "What challenges did you face this week?",
    reflections_4_30: "How can you overcome them next week?",
    reflections_4_40: "What's mostly missing from your life right now?",
    reflections_4_50: "What's one thing you want to change or improve next week?",
    reflections_4_60: "What were your major accomplishments this week?",
    reflections_5_10: "What lessons did you learn this week?",
    reflections_5_20: "What do you want to accomplish next week?",
    reflections_5_30: "What's driving you?",
    reflections_5_40: "What's stopping you?",
    reflections_5_50: "What can you do to overcome it?",
    midday_10: "What's going well in my life right now? What should I be grateful for?",
    midday_20: "What am I trying to avoid or delay (procrastinate) but should do anyway?",
    midday_30: "What do I still need to accomplish today?",
    midday_40: "What is the main obstacle or challenge I am currently facing?",
    midday_50: "What are possible solutions?",
  },

  trialPeriod: '7-Day Trial',

  plans: [
    {
      code: 'PRO-328880',
      cost: 19,
      description: '$19.00 USD per month',
      months: 1,
      title: '1 Month $19.00 USD',
    },
    {
      code: 'PRO-328882',
      cost: 39,
      description: '$39.00 USD for 3 months',
      months: 3,
      save: '32%',
      title: '3 Months $39.00 USD',
    },
    {
      code: 'PRO-328883',
      cost: 69,
      description: '$69.00 USD for 6 months',
      months: 6,
      save: '40%',
      tip: '7-Day Trial',
      title: '6 Months $69.00 USD',
    },
  ],

  archivedPlans: [
    {
      code: 'GIFT',
      cost: 0,
      months: 2,
      title: 'Gift',
    }
  ],

  videos: {
    activities: 'https://goalswizard.s3.amazonaws.com/New_Daily_Habits-1.mp4',
    firstGoal: 'https://goalswizard.s3.amazonaws.com/Key_Goals_to_Keep_Your_Life_in_Balance.mp4',
    goals: 'https://goalswizard.s3.amazonaws.com/Goal%20Setting-1.mp4',
    milestones: 'https://goalswizard.s3.amazonaws.com/Action%20Planning-1.mp4',
    // morningThoughts: 'https://www.youtube.com/embed/E_nXURSDur4',
    // routines: 'https://www.youtube.com/embed/0cmMjeC4FU8',
    today: 'https://goalswizard.s3.amazonaws.com/Goal_Setting_Success-1.mp4',
    vision: 'http://goalswizard.s3.amazonaws.com/The%20Power%20Of%20Visualization-1.mp4',
    welcome: 'https://goalswizard.s3.amazonaws.com/Goal_Setting-1.mp4',
    clarity: {
      intro: 'https://goalswizard.s3.amazonaws.com/Goal_Setting-1.mp4',
    },
    identity: {
      // beliefs: 'https://www.youtube.com/embed/fmyQGqxUvVo',
      dreams: 'https://goalswizard.s3.amazonaws.com/Dare_to_Dream_Bigger.mp4',
      // habits2: 'https://www.youtube.com/embed/3MDza5vETjI',
      habits: 'https://goalswizard.s3.amazonaws.com/New_Habits-1.mp4',
      intro: 'https://goalswizard.s3.amazonaws.com/Your_Self_Concept-1.mp4',
      // passion2: 'https://www.youtube.com/embed/6kQkH9Ndqv8',
      // passion: 'https://www.youtube.com/embed/7OKGOxxZe18',
      // purpose2: 'https://www.youtube.com/embed/kj17W78c2VM',
      // purpose: 'https://www.youtube.com/embed/YOnlmVZ2JSY',
      // strengths2: 'https://www.youtube.com/embed/DeoufyV59uw',
      // strengths: 'https://www.youtube.com/embed/CH1iQAjRYnI',
      // values2: 'https://www.youtube.com/embed/sSvSGYemie8',
      values: 'https://goalswizard.s3.amazonaws.com/Your_Personal_Values-1.mp4#t=0.1',
      vision: 'https://goalswizard.s3.amazonaws.com/Idealization-1.mp4',
    }
  }
}
